/* eslint-disable @typescript-eslint/no-misused-promises */
'use client'
import { LoadingButton } from '@/components/ui/loading-button'
import { ChevronRight } from 'lucide-react'

export const BuyButton = ({
  loading,
  disabled,
  onClick,
  text = '購入画面に進む',
  chevron = true,
  addCart = false,
  promotionModal = false,
}: {
  loading: boolean
  disabled: boolean
  onClick: () => void
  text?: string
  chevron?: boolean
  addCart?: boolean
  promotionModal?: boolean
}) => {
  let className =
    'main-loading-button button-color main-color w-full text-base rounded-lg text-center relative font-semibold p-5 h-[50px] text-white'
  if (addCart) {
    className = 'button-color-reverse main-color-reverse' + ' ' + className
  }
  if (promotionModal && !addCart) {
    className = 'promotion-modal-buy-button' + ' ' + className
  }
  if (promotionModal && addCart) {
    className = 'promotion-modal-add-cart-button' + ' ' + className
  }
  return (
    <div className="item-buy-button text-center w-full bg-white">
      <LoadingButton
        loading={loading}
        className={className}
        disabled={disabled}
        onClick={onClick}
      >
        {text}
        {chevron && (
          <span
            className="absolute font-bold text-2xl"
            style={{ color: '#fff', top: '15px', right: '12px' }}
          >
            <ChevronRight strokeWidth={'3px'} width={20} height={20} />
          </span>
        )}
      </LoadingButton>
    </div>
  )
}
